var Exchange = (function ($) {

    Exchange = function (options) {
        var that = this;

        options = options || {};

        // CONST
        that.order_hash = options['order_hash'] || null;
        that.order_passenger_hash = options['order_passenger_hash'] || null;
        that.modals = options['modals'] || {};
        that.locales = options['locales'] || {};
        that.passengers_category_types = options['passengers_category_types'] || [];
        that.segments_main_data = options['segments_main_data'] || [];
        that.is_show_order_contact_data_modal = options['is_show_order_contact_data_modal'] || false;
        that.order_url = that.order_passenger_hash ?
            $.sa.build_url('order/' + that.order_hash + '-' + that.order_passenger_hash) :
            $.sa.build_url('order/' + that.order_hash);

        that.step_ids = ['passengers', 'segments', 'desired_date', 'desired_segments', 'checkout'];
        that.class = {
            hidden: 'hidden',
            disabled: 'disabled',
            current: 'current',
            narrow: 'narrow',
            close_drawer: 'js-close-drawer'
        };
        that.selectors = {
            screen: '.js-screen',
            exchange_form: '.js-exchange-form',
            footer_wrapper: '.js-footer-wrapper',
            passengers_screen: '.js-passengers-screen',
            segments_screen: '.js-segments-screen',
            desired_date_screen: '.js-desired-date-screen',
            desired_segments_screen: '.js-desired-segments-screen',
            checkout_screen: '.js-checkout-screen',
            step: '.js-step',
            button_next: '.js-button-next'
        };

        // DOM
        that.$wrapper = options['$wrapper'];
        that.$exchange_form = that.$wrapper.find(that.selectors.exchange_form);
        that.$steps = that.$wrapper.find(that.selectors.step);
        that.$screens = that.$wrapper.find(that.selectors.screen);
        that.$footer_wrapper = that.$wrapper.find(that.selectors.footer_wrapper);
        that.$button_next = that.$wrapper.find(that.selectors.button_next);

        // DYNAMIC VARS
        that.is_locked = false;
        that.current_step_id = 'passengers';
        that.screens = {};
        that.current_screen = null;
        that.is_finish = false;
        that.ui_steps = null;

        // INIT
        that.init();
    };

    Exchange.prototype.init = function () {
        var that = this;

        that.__initPassengersScreen();

        that.__initSegmentsScreen();

        that.__initDesiredDateScreen();

        that.__initDesiredSegmentsScreen();

        that.__initCheckoutScreen();

        that.__setActiveScreen(that.__getScreenById('passengers'));

        that.__initStepControlsEvents();

        that.ui_steps = new UISteps();
    };

    Exchange.prototype.__initStepControlsEvents = function () {
        var that = this;

        that.$steps.on('click', function () {
            var step_id = $(this).data('id');

            that.__changeStep(step_id, step_id === that.__getNextStepId());
        });

        that.$button_next.on('click', function () {
            var next_step_id = that.__getNextStepId();

            if (that.is_finish) {
                // redirect to the page of a divided order or current one
                $.sa.content_router.load(that.order_url);
                return;
            }

            if (next_step_id !== null) {
                that.__changeStep(that.__getNextStepId(), true);
            } else {
                that.__proceedPayment();
            }
        });
    };

    Exchange.prototype.__changeStep = function (step_id, is_next_step = false) {
        var that = this;

        if (that.is_locked || false === that.__isAvailableStep(step_id)) {
            return;
        }

        that.__stepActionsStart();
        if (is_next_step) {
            if (true === that.current_screen.isValid()) {
                that.__switchStep(step_id).always(function () {
                    that.__stepActionsFinish();
                });
            } else {
                that.__stepActionsFinish();
            }
        } else {
            that.__switchStep(step_id).always(function () {
                that.__stepActionsFinish();
            });
        }
    };

    /**
     *
     * @private
     */
    Exchange.prototype.__stepActionsStart = function () {
        var that = this;

        that.is_locked = true;
        $.sa.buttonLoading(that.$button_next, true);
        that.$wrapper.find(that.selectors.step).addClass(that.class.disabled);
    }

    /**
     *
     * @private
     */
    Exchange.prototype.__stepActionsFinish = function () {
        var that = this,
            $current_step = that.$wrapper.find(that.selectors.step + '.' + that.class.current);

        that.is_locked = false;
        $.sa.buttonLoading(that.$button_next, false);
        var $next_available_step = $current_step.is(':last-child') ? $current_step : $current_step.next();
        $next_available_step.removeClass(that.class.disabled).prevAll().removeClass(that.class.disabled);
    }

    Exchange.prototype.__proceedPayment = function () {
        var that = this,
            $close_button = that.$wrapper.find('.drawer-header .' + that.class.close_drawer);

        if (that.is_locked) {
            return;
        }

        that.__stepActionsStart();
        that.current_screen.beforeUnload();
        if (true === that.current_screen.isValid()) {
            $close_button.addClass(that.class.hidden);
            that.current_screen.proceedPayment(that.__formatData(that.__getData())).done(function (res) {
                if (true === res) {
                    that.$wrapper.find(that.selectors.step + '.' + that.class.current).prevAll().addClass(that.class.disabled);
                    that.$footer_wrapper.addClass(that.class.hidden);
                    that.$exchange_form.addClass(that.class.narrow);
                    setTimeout(() => {
                        $.sa.$window.resize();
                    }, 2000);
                } else {
                    that.is_finish = true;
                    that.$button_next.addClass(that.class.disabled);
                    $close_button.removeClass(that.class.hidden);
                    that.__stepActionsFinish();
                }
                that.current_screen.afterLoad();
            });
        } else {
            that.__stepActionsFinish();
            that.current_screen.afterLoad();
        }
    };

    Exchange.prototype.__initPassengersScreen = function () {
        var that = this;

        that.screens.passengers = new ExchangePassengersScreen({
            $wrapper: that.$wrapper.find(that.selectors.passengers_screen),
            modals: that.modals,
            locales: that.locales,
            passengers_category_types: that.passengers_category_types
        });
    };

    Exchange.prototype.__initSegmentsScreen = function () {
        var that = this;

        that.screens.segments = new ExchangeSegmentsScreen({
            $wrapper: that.$wrapper.find(that.selectors.segments_screen),
            modals: that.modals,
            locales: that.locales,
            segments_main_data: that.segments_main_data,
            onError: function () {
                that.__changeStep(that.__getFirstStepId());
            }
        });
    };

    Exchange.prototype.__initDesiredDateScreen = function () {
        var that = this;

        that.screens.desired_date = new ExchangeDesiredDateScreen({
            $wrapper: that.$wrapper.find(that.selectors.desired_date_screen),
            order_hash: that.order_hash,
            order_passenger_hash: that.order_passenger_hash,
            modals: that.modals,
            locales: that.locales
        });
    };

    Exchange.prototype.__initDesiredSegmentsScreen = function () {
        var that = this;

        that.screens.desired_segments = new ExchangeDesiredSegmentsScreen({
            $wrapper: that.$wrapper.find(that.selectors.desired_segments_screen),
            order_hash: that.order_hash,
            order_passenger_hash: that.order_passenger_hash,
            modals: that.modals,
            locales: that.locales,
            order_url: that.order_url
        });
    };

    Exchange.prototype.__initCheckoutScreen = function () {
        var that = this;

        that.screens.checkout = new ExchangeCheckoutScreen({
            $wrapper: that.$wrapper.find(that.selectors.checkout_screen),
            order_hash: that.order_hash,
            order_passenger_hash: that.order_passenger_hash,
            modals: that.modals,
            locales: that.locales,
            order_url: that.order_url,
            is_show_order_contact_data_modal: that.is_show_order_contact_data_modal,
            onValid: function () {
                that.__proceedPayment();
            },
            onPayment: function () {
                $.sa.buttonLoading(that.$button_next, false);
                that.$button_next.removeClass(that.class.disabled).addClass(that.class.close_drawer).text(that.locales.back_to_order);
                that.$wrapper.find(that.selectors.step + '.' + that.class.current).removeClass(that.class.disabled);
                that.$footer_wrapper.removeClass(that.class.hidden);
                that.$exchange_form.removeClass(that.class.narrow);
                that.is_finish = true;

                $.sa.$window.resize();
            }
        });
    };

    Exchange.prototype.__getData = function () {
        var that = this,
            data = {};

        for (var key in that.screens) {
            data[key] = that.screens[key].getData();
            if (key === that.__getCurrentStepId()) {
                break;
            }
        }

        return data;
    };

    Exchange.prototype.__formatData = function (data) {
        var formatted_data = {},
            params = {
                passengers: 'passenger_hashes',
                segments: 'segment_hash',
                desired_date: 'desired_date',
                desired_segments: 'variant_hash'
            };

        for (var key in data) {
            formatted_data[params[key]] = data[key]['value'];
        }

        return formatted_data;
    };

    Exchange.prototype.__switchStep = function (step_id) {
        var that = this,
            deferred = $.Deferred(),
            data = that.__getData();

        that.current_screen.beforeUnload();
        if (step_id === 'desired_segments' || step_id === 'checkout') {
            that.screens[step_id].init(that.__formatData(data)).done(function (response) {
                if (false !== response) {
                    if (step_id === 'checkout') {
                        data.checkout = response;
                    }
                    that.__switchContent(step_id, data);
                } else {
                    that.current_screen.showError();
                    that.current_screen.afterLoad();
                }
                deferred.resolve(response);
            }).fail(function (error) {
                that.current_screen.showError();
                that.current_screen.afterLoad();
                deferred.reject(error);
            });
        } else {
            that.__switchContent(step_id, data);
            deferred.resolve(true);
        }

        return deferred.promise();
    };

    Exchange.prototype.__switchContent = function (step_id, data) {
        var that = this,
            $active_step = that.$wrapper.find(that.selectors.step + '[data-id=' + step_id + ']');

        that.$steps.removeClass(that.class.current).removeClass(that.class.disabled);
        $active_step.addClass(that.class.current).next().nextAll().addClass(that.class.disabled);

        that.$screens.addClass(that.class.hidden);
        that.$wrapper.find('.js-' + step_id.replace('_', '-') + '-screen').removeClass(that.class.hidden);

        if (step_id === 'checkout') {
            var payment_total = data.checkout.total ? parseFloat(data.checkout.total) : 0;
            that.$button_next.text(payment_total === 0 ? that.locales.complete_exchange : that.locales.proceed_to_payment);
        } else {
            that.$button_next.text(that.locales.continue);
        }

        var direction = data.hasOwnProperty('segments') ? data.segments.selected_segment : {};
        that.__setCurrentStepId(step_id);
        that.__setActiveScreen(that.__getScreenById(step_id));
        if (step_id === 'segments') {
            that.current_screen.afterLoad(data.passengers.value);
        } else {
            that.current_screen.afterLoad(direction);
        }
        that.ui_steps.updateStepVisibility();
    };

    /**
     * @returns {string}
     * @private
     */
    Exchange.prototype.__getCurrentStepId = function () {
        return this.current_step_id;
    };

    /**
     * @returns {string|null}
     * @private
     */
    Exchange.prototype.__getNextStepId = function () {
        var that = this;

        var current_index = that.step_ids.indexOf(that.__getCurrentStepId());

        if (current_index === that.step_ids.length - 1) {
            return null;
        }

        return that.step_ids[current_index + 1];
    };

    /**
     * @returns {string}
     * @private
     */
    Exchange.prototype.__getFirstStepId = function () {
        return this.step_ids[0];
    };

    /**
     * @returns {string}
     * @private
     */
    Exchange.prototype.__getLastStepId = function () {
        return this.step_ids[this.step_ids.length - 1];
    };

    /**
     * @param step_id
     * @returns {boolean}
     * @private
     */
    Exchange.prototype.__isAvailableStep = function (step_id) {
        var that = this;

        var current_index = that.step_ids.indexOf(that.__getCurrentStepId());
        var possible_index = that.step_ids.indexOf(step_id);

        return possible_index !== -1 && (possible_index < current_index || possible_index === current_index + 1);
    };

    /**
     * @param step_id
     * @private
     */
    Exchange.prototype.__setCurrentStepId = function (step_id) {
        this.current_step_id = step_id;
    };

    /**
     * @private
     */
    Exchange.prototype.__getCurrentScreen = function () {
        return this.current_screen;
    };

    /**
     * @param screen_id
     * @returns {*}
     * @private
     */
    Exchange.prototype.__getScreenById = function (screen_id) {
        return this.screens[screen_id];
    };

    /**
     * @param screen
     * @private
     */
    Exchange.prototype.__setActiveScreen = function (screen) {
        this.current_screen = screen;
    };

    return Exchange;
})($);
